import { Reserved } from './client/Sections.tsx';

/**
 * A module the toolbar shows before anything is behind it (docs/navigation-brief.md,
 * section 7): shown, so the layout approved is the layout that fills in, and
 * plainly labelled, so it never reads as broken.
 */
export function ReservedModule({ which }: { which: 'finance' | 'documents' }) {
  return (
    <div className="min-h-dvh bg-page">
      <div className="mx-auto max-w-[96rem] px-4 py-6 lg:px-6">
        {which === 'finance' ? (
          <Reserved title="Finance">
            Marshalling in progress, accounts and benefits across every client: money a client has or is owed, Social
            Security entitlements, and the accounts being closed and moved into the guardianship account. Compensation
            is its own module, beside this one.
          </Reserved>
        ) : (
          <Reserved title="Documents">
            Incoming documents to file: the scan pile, each document filed to its client and kept or shredded. Until
            this is built, documents are filed where they are today.
          </Reserved>
        )}
      </div>
    </div>
  );
}
